export default {
  EVENT_VIEW: 'EVENT_VIEW',
  TIMELIST: 'TIMELIST',
  TOP_OFFER: 'TOP_OFFER',
};
